import { useEffect, useCallback } from "react";

function useUnsavedChangesWarning(shouldWarn, warningMessage = "You have unsaved changes. Are you sure you want to leave?") {
  const triggerWarning = useCallback(() => {
    if (shouldWarn) {
      return window.confirm(warningMessage);
    }
    return true;
  }, [shouldWarn, warningMessage]);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (shouldWarn) {
        event.preventDefault();
        event.returnValue = ""; // triggers the browser's built-in dialog
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [shouldWarn]);

  return triggerWarning;
}

export default useUnsavedChangesWarning;
